var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('admin-iframe',{attrs:{"src":_vm.remoteSrc,"isNcua":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }